import React from 'react';
import { Box } from '@material-ui/core';

/**
 * Header Container Component
 * Sticky header container
 */
const Header = ({ children, padding = 8, style, hide, ...props }) => (
  <Box
    component="header"
    style={{
      padding: `${padding}px`,
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #e0e0e0',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      ...style,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default Header;
